// Configurações de ambiente da aplicação
import { APP_VERSION as PACKAGE_VERSION } from '../buildVersion';

const PRODUCTION_API = 'https://apicargo.sendingto.com';

const resolveApiBaseUrl = (): string => {
  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).replace(/\/?$/, '/');
  }
  return `${PRODUCTION_API}/`;
};

export const config = {
  /** Host da API, ex.: https://apicargo.sendingto.com/ */
  API_BASE_URL: resolveApiBaseUrl(),
  APP_NAME: process.env.REACT_APP_APP_NAME || 'SendingTo Express',
  /** Atualizado automaticamente em `npm run build:prod` (patch +1). */
  APP_VERSION: process.env.REACT_APP_VERSION || PACKAGE_VERSION,
  ENVIRONMENT: process.env.NODE_ENV || 'development',
};

export const isDevelopment = config.ENVIRONMENT === 'development';
export const isProduction = config.ENVIRONMENT === 'production';

/** Prefixo REST: https://apicargo.sendingto.com/api/v1 */
export const API_V1_BASE = `${String(config.API_BASE_URL).replace(/\/$/, '')}/api/v1`;

export const apiConfig = {
  baseURL: config.API_BASE_URL,
  assetBaseURL: String(config.API_BASE_URL).replace(/\/$/, ''),
  apiV1Base: API_V1_BASE,
  timeout: 10000,
  retryAttempts: 3,
  endpoints: {
    login: '/api/v1/login',
    logout: '/api/v1/logout',
    refresh: '/api/v1/refresh',
    profile: '/api/v1/profile',
  },
};
